export const getRetinaMod = () => (devicePixelRatio > 1 ? '@2x' : '');
